// NOTE: to update the checksum, you need to run the following command:
// this needs to be run for each selector thats expected to be sent to gift card factory
// document.querySelector().dispatchEvent(new Event('input', { bubbles: true, cancelable: true }))

window.GiftCardPostman = window.GiftCardPostman || {}
class GiftCardPostman {
  constructor(data) {
    this.data = data
    this.settings = {
      checksum_property_title: "_gcp_checksum",
      extra_input_field_ids: ['recipient_name', 'recipient_email', 'scheduled_at', 'message', 'template_id', 'gift-card-custom-amount', 'giftcard-type']
    }
    this.selectors = {
      appInput: '.gift-card-postman__fields-container input, .gift-card-postman__fields-container textarea',
      storeForm: 'form[action="/cart/add"]',
      giftCheckbox: '[id="gift_option"]',
      scheduledAt: '#scheduled_at'
    }
    this.giftCardProperties = {}
    this.bindInputListeners.bind(this);

    this.bindInputListeners();
    this.setTemplateID()
    document.querySelector(this.selectors.giftCheckbox).dispatchEvent(new Event('input', { bubbles: true, cancelable: true }))
    setTimeout(() => {
      document.querySelectorAll(this.selectors.appInput).forEach((el) => {
        el.value = null
        this.setCurrentScheduleDate()
      })
    }, 500)
  }


  bindInputListeners() {
    self = this
    document.querySelectorAll(this.selectors.appInput).forEach((el) => {
      el.addEventListener("input", this.inputChanged.bind(this))
    })
  }

  setCurrentScheduleDate() {
    document.querySelectorAll(this.selectors.scheduledAt).forEach((el) => {
      const dt = new Date();
      dt.setMinutes(dt.getMinutes() - dt.getTimezoneOffset());
      const currentDate = dt.toISOString().slice(0, 16)
      el.value = currentDate
      el.min = currentDate
      el.dispatchEvent(new Event('input', { bubbles: true, cancelable: true }))
    })
  }

  setTemplateID() {
    if (window.giftcard && window.giftcard.templateID) {
      let template = document.querySelector('#template_id')
      if (template) {
        template.value = window.giftcard.templateID
      }
    } else {
      console.warn('no template id to available to set')
    }
  }

  inputChanged(event) {
    const inputName = event.target.name;
    const inputValue = event.currentTarget.type == 'checkbox' ? event.currentTarget.checked : event.target.value;
    const inputId = event.target.id
    const giftCardPostmanHiddenFieldSelector = `input[type="hidden"][name="properties[${this.settings.checksum_property_title}]"]`
    this.giftCardProperties[inputId] = inputValue;
    const sectionElement = event.target.closest('section')
      || event.target.closest('.shopify-section')
      || document.querySelector('.product-section')
    const forms = sectionElement.querySelectorAll(this.selectors.storeForm)
    var self = this
    const isInputGiftOption = inputName === "properties[_gift_option]"
    const isGiftOptionDeselected = isInputGiftOption && !event.currentTarget.checked

    if(isGiftOptionDeselected) {
      const fieldsToRemove = self.settings.extra_input_field_ids.map(id => document.querySelector(`.gcp-form-fields #${id}`)?.name)
      fieldsToRemove.map(fieldToRemove => {
        document.querySelectorAll(`input[type="hidden"][name="${fieldToRemove}"]`).forEach(el => el.remove())
      })
      document.querySelectorAll(giftCardPostmanHiddenFieldSelector).forEach(el => el.remove())
      document.querySelectorAll(this.selectors.appInput).forEach((el) => {
        el.value = null
      })
      this.giftCardProperties = {}
    } else if(isInputGiftOption) {
      this.setCurrentScheduleDate()
    }

    forms.forEach(el => {
      const selector = `input[type="hidden"][name="${inputName}"]`
      const inputExists = el.querySelectorAll(selector);
      if(inputExists.length) {
        if(inputValue || event.currentTarget.type == 'checkbox') {
          inputExists[0].value = inputValue
        } else {
          inputExists[0].remove();
        }
      } else {
        var input = document.createElement('input')
        input.type = "hidden"
        input.name = inputName
        input.value = inputValue
        el.appendChild(input)
      }
      if(!isGiftOptionDeselected) {
        this.setTemplateID()
        const giftCardPostmanHiddenField = el.querySelectorAll(giftCardPostmanHiddenFieldSelector);
        const checksum = btoa(unescape(encodeURIComponent(JSON.stringify(this.giftCardProperties))))
        if(giftCardPostmanHiddenField.length) {
          giftCardPostmanHiddenField[0].value = checksum
        } else {
          var gcpInput = document.createElement('input')
          gcpInput.type = "hidden"
          gcpInput.name = `properties[${self.settings.checksum_property_title}]`
          gcpInput.value = checksum
          el.appendChild(gcpInput)
        }
      }
    })
  }
}

if (!(typeof window.GiftCardPostman === 'undefined' || window.GiftCardPostman === null)) {
  const productId = document.querySelector('#gift-card-postman')?.getAttribute('data-product-id')
  if (!productId) {
    console.warn('Error finding product id.')
  }
  new GiftCardPostman({id: productId })
}
